// extracted by mini-css-extract-plugin
export default {"default":"EditableSelectCell_default__DkWyk"};